<template>
    <div v-show="visible">
        <el-dialog title="导出配置" :close-on-click-modal="false" :visible.sync="visible" 
            v-loading="loading"
            :element-loading-text="loadingText"
            element-loading-spinner="el-icon-loading"
            :before-close="dialogClose" width="450px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="100px">    
                <el-form-item   prop="scoreType" label="排序方式：">
                    <el-select v-model="form.sortType" style="width:150px;">
                        <el-option
                            v-for="item in scoreTypes"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item  label="范围类型："  v-if="form.setGradeSign == 0">
                    <el-select v-model="form.rangeType" style="width:150px;">
                        <el-option
                            v-for="item in rangeTypes"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">关闭</el-button>
                <el-button type="primary" @click="save()">确定导出</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import axios from 'axios';
    import http from '../../../../common/http';

    export default {
        data(){
            return{
                visible: false,
                loading:false,
                loadingText:"",
                form:{
                    deptId:"",
                    startDate:"",
                    endDate:"",
                    evaluateTitle:"",
                    name:"",
                    gradeName:"",
                    sortType:1, // 排序方式-sortType(总分-1、部门人员-2)。
                    rangeType:1, 
                    setGradeSign:"" // 年级 小学（1-6），初中（7-9） 是否存在（-1-不存在，0-存在）
                },
                rules: {
                },
                scoreTypes:[
                    {
                        'value':1,
                        'label':'总分'
                    }
                    // ,{
                    //     'value':2,
                    //     'label':'部门人员'
                    // }
                ],
                rangeTypes:[
                    {
                        'value':1,
                        'label':'全校'
                    },{
                        'value':2,
                        'label':'小学'
                    },{
                        'value':3,
                        'label':'初中'
                    }
                ],
            }
        },
        created:function () {
        },
        methods:{
            init(data){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                // 初始值
                this.form.sortType = 1;
                this.form.rangeType = 1;
                
                this.form.startDate = data.startDate;
                this.form.endDate = data.endDate;
                this.form.deptId = data.deptId;
                this.form.evaluateTitle = data.evaluateTitle;
                this.form.name = data.name;
                this.form.gradeName = data.gradeName;
                // 年级 小学（1-6），初中（7-9） 是否存在（-1-不存在，0-存在）
                this.form.setGradeSign = data.setGradeSign;
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){

                this.loading=true;
                this.loadingText="正在导出中，导出过程时间可能会比较长，请耐心等待";

                let url=this.evaluateDetailArchiveTeacherExportUrl;
                let param = new URLSearchParams();
                param.append('deptId', this.form.deptId);
                param.append('startDate', this.form.startDate);
                param.append('endDate', this.form.endDate);
                // 排序方式-sortType(总分-1、部门人员-2)。
                param.append('sortType',this.form.sortType);
                param.append('evaluateTarget',3);
                param.append('evaluateModule',5);
                // param.append('evaluateTitle',this.form.evaluateTitle);
                // param.append('name',this.form.name);
                // param.append('gradeName',this.form.gradeName);
                if(this.form.setGradeSign == 0){
                    // 范围类型-范围类型（全校（1）、小学（2）、初中（3））。
                    param.append('rangeType',this.form.rangeType);
                }

                let reg=new RegExp('-','g')
                let startDate=this.form.startDate.replace(reg,'.');
                let endDate=this.form.endDate.replace(reg,'.');
                let fileName="教职评价统计"+"("+startDate+"-"+endDate+")";

                axios({
                    method: "post",
                    url: url,
                    data: param,
                    responseType: "blob"
                }).then(res => {
                    const link = document.createElement("a");
                    let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute("download", fileName+'.xls');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.loading=false;
                }).catch(error => {
                    console.log(error);
                    this.loading=false;
                });

            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/evaluateArchive/TeacherEvaluateExprot.vue